import axios from 'axios'
import { ElMessage } from 'element-plus'

// 创建axios实例
const isProduction = process.env.NODE_ENV === 'production'
const service = axios.create({
  baseURL: isProduction ? process.env.VUE_APP_BASE_API : '/api',
  timeout: 5000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    // 例如：添加token
    // if (store.getters.token) {
    //   config.headers['Authorization'] = `Bearer ${store.getters.token}`
    // }
    return config
  },
  error => {
    // 对请求错误做些什么
    console.log(error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    return response
    // const res = response.data
    //
    // // 根据业务状态码处理
    // if (res.code !== 200) {
    //   ElMessage.error(res.message || 'Error')
    //   return Promise.reject(new Error(res.message || 'Error'))
    // } else {
    //   return res
    // }
  },
  error => {
    console.log('err' + error)
    ElMessage.error(error.message)
    return Promise.reject(error)
  }
)

export default service
